/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { NameCell_ConfigurationFragmentDoc } from '../Cell/__generated__/NameCell.graphql';
import { StatusCell_ConfigurationFragmentDoc } from '../Cell/__generated__/StatusCell.graphql';
import { DescriptionCell_ConfigurationFragmentDoc } from '../Cell/__generated__/DescriptionCell.graphql';
import { PlatformCell_ConfigurationFragmentDoc } from '../Cell/__generated__/PlatformCell.graphql';
import { CreatedOnCell_ConfigurationFragmentDoc } from '../Cell/__generated__/CreatedOnCell.graphql';
import { DraftStatusCell_ConfigurationFragmentDoc } from '../Cell/__generated__/DraftStatusCell.graphql';
export type ConfigurationTable_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, customerId: string, platform: string, name: string, state: Types.ConfigurationStatus, description?: string | null, createdAt: any, version: number, draft?: { __typename: 'ConfigurationModel', id: string, name: string, description?: string | null, state: Types.ConfigurationStatus, platform: string } | null };

export const ConfigurationTable_ConfigurationFragmentDoc = gql`
    fragment ConfigurationTable_configuration on ConfigurationModel {
  id
  customerId
  platform
  draft {
    id
    name
    description
    state
    platform
  }
  ...NameCell_configuration
  ...StatusCell_configuration
  ...DescriptionCell_configuration
  ...PlatformCell_configuration
  ...CreatedOnCell_configuration
  ...DraftStatusCell_configuration
}
    ${NameCell_ConfigurationFragmentDoc}
${StatusCell_ConfigurationFragmentDoc}
${DescriptionCell_ConfigurationFragmentDoc}
${PlatformCell_ConfigurationFragmentDoc}
${CreatedOnCell_ConfigurationFragmentDoc}
${DraftStatusCell_ConfigurationFragmentDoc}`;